module.exports = __webpack_public_path__ + "img/privilege.149b96e9.svg";